<vg-player [class]="customClass" (onPlayerReady)="initVideoPlayer($event)">
	<vg-overlay-play [hidden]="hideControls"></vg-overlay-play>

	@if (!hideControls && videoStarted || !thumbnail) {
		<vg-controls [vgAutohide]="true" [vgAutohideTime]="1">
		  <vg-play-pause></vg-play-pause>

		  <vg-scrub-bar class="scrub-bar">
			<vg-scrub-bar-current-time></vg-scrub-bar-current-time>
			<vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
			@if (seekDisabled) {
				<div
					class="scrub-bar-lock"
					[style.left.%]="watchedPercent"
					[style.width.%]="100 - watchedPercent"
					(mousedown)="$event.stopPropagation()"
					(touchstart)="$event.stopPropagation()"
					(click)="$event.stopPropagation()"
				></div>
			}
		  </vg-scrub-bar>

		  <vg-time-display vgProperty="current" vgFormat="mm:ss" class="time-color"></vg-time-display>
		  <span class="time-color bar">/</span>
		  <vg-time-display vgProperty="total" vgFormat="mm:ss" class="time-color"></vg-time-display>

		  @if (normalizedSubtitles?.length) {
			<vg-track-selector vgFor="my-video"></vg-track-selector>
		  }

		  <vg-mute></vg-mute>
		  <vg-volume></vg-volume>

		  <vg-fullscreen></vg-fullscreen>
		</vg-controls>
	}

		<video
			#media
			(timeupdate)="onTimeUpdate(media)"
			[poster]="thumbnail"
			[attr.controls]="!hideControls ? true : null"
			crossorigin="anonymous"
			preload="auto"
			playsinline
			webkit-playsinline
			width="100%"
			[controls]="false"
			[vgMedia]="$any(media)"
			(play)="onPlay($event)"
			(pause)="onPause($event)"
			(seeking)="onSeeking($event)"
       		(seeked)="onSeeked($event)"
			(ended)="onEnded($event)"
		>
		@for (subtitle of normalizedSubtitles; track $index) {
			<track
			kind="subtitles"
			[label]="subtitle?.label | translateWithKeys"
			[src]="subtitle?.url"
			[srclang]="subtitle?.code"
			[default]="subtitle?.code === currentLanguage"
			/>
		}
		</video>

  </vg-player>
